<template>
  <div class="cart-data animated">
    <div
      class="left-arrow cart-summary-toggle"
      role="button"
      tabindex="0"
      aria-label="Toggle cart summary"
      @keydown.enter.prevent="$event.currentTarget.click()"
      @keydown.space.prevent="$event.currentTarget.click()"
    >
      <i class="fa fa-angle-left"></i>
      <span class="cart-summary-info">
        <span class="cart-summary-icon">
          <img src="@/assets/images/icons/bag.png" alt="Shopping-bag" />
        </span>
        <span class="cart-summary-count">
          <span v-if="globalLanguage == 'EN'">
            {{ carts.length || 0 }} item{{ carts.length == 1 ? "" : "s" }}
          </span>
          <span v-else>{{ carts.length || 0 }} টি পণ্য</span>
        </span>
        <span class="cart-summary-total"
          >{{ (sumCartTotal || 0).toFixed(2) }} &#8364;</span
        >
      </span>
    </div>

    <div class="product-lists" v-if="carts.length > 0">
      <div class="cart-items-bar">
        <img
          src="@/assets/images/icons/bag.png"
          alt="Shopping-bag"
          height="17px"
          class="pull-left"
        />
        &nbsp;&nbsp;<b>{{ carts.length }}</b>&nbsp;&nbsp;
        <span v-if="globalLanguage == 'EN'">Items in Cart</span>
        <span v-else>পণ্য কার্টে</span>
      </div>

      <table class="table table-striped table-responsive">
        <tr
          v-for="cart in carts"
          v-bind:id="cart.product_id"
          v-bind:key="cart.product_id"
        >
          <td class="remove-td">
            <div @click="$emit('remove-cart-item', cart.product_id)">
              <img
                src="@/assets/images/icons/close-x.png"
                class="img-responsive"
              />
            </div>
          </td>
          <td class="product-image-td">
            <div>
              <img
                v-bind:src="fileUrl + 'uploads/products/' + cart.product_image"
                class="img-responsive"
              />
            </div>
          </td>
          <td
            class="product-name-td"
            @click="$emit('cart-increment', cart.product_id)"
          >
            <div>
              <span v-if="globalLanguage == 'EN'">{{ cart.product_name }}</span>
              <span v-else>{{ cart.product_name_bn }}</span>
              <br /><small>
                {{ cart.price.toFixed(2) }} &#8364; / {{ cart.quantity }}
                {{ cart.unit }}</small
              >
            </div>
          </td>
          <td class="cart-total-td">
            <div class="text-right cart-quantity">
              <div class="border-line cart-stepper" role="group">
                <button
                  type="button"
                  class="cart-stepper-btn"
                  data-toggle="tooltip"
                  data-placement="left"
                  @click="$emit('cart-decrement', cart.product_id)"
                >
                  -
                </button>
                <div class="cart_quantity">{{ cart.cart_quantity }}</div>
                <button
                  type="button"
                  class="cart-stepper-btn"
                  data-toggle="tooltip"
                  data-placement="left"
                  @click="$emit('cart-increment', cart.product_id)"
                >
                  +
                </button>
              </div>
            </div>
            <span class="base-color"></span>
            <span class="cart-row-total"
              >{{ cart.subtotal.toFixed(2) }} &#8364;</span
            >
          </td>
        </tr>
      </table>
    </div>

    <div class="text-center checkoutlink" v-if="carts.length > 0">
      <router-link type="button" to="/cart" class="cart-page-button">
        <span class="cart-page-text">
          <i class="fa fa-shopping-cart"></i>
          <span v-if="globalLanguage == 'EN'">View Cart</span>
          <span v-else>কার্ট দেখুন</span>
        </span>
        <i class="fa fa-angle-right"></i>
      </router-link>
      <router-link type="button" to="/checkout" class="cart-checkout-button">
        <span class="cart-checkout-text">GO CHECKOUT</span>
        <span class="cart-checkout-price"
          >{{ sumCartTotal.toFixed(2) }} &#8364;</span
        >
      </router-link>
    </div>

    <div class="text-center empty-cart" v-if="carts.length <= 0">
      <div class="text-center">
        <img src="@/assets/images/icons/emptycart.png" alt="" />
        Your Cart Is Empty.Please Add <br />
        Product In Your BAG..
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartData",
  props: {
    carts: {
      type: Array,
      default: function() {
        return [];
      }
    },
    fileUrl: {
      type: String,
      required: true
    },
    globalLanguage: {
      type: String,
      required: true
    },
    sumCartTotal: {
      type: Number,
      default: 0
    }
  }
};
</script>
